<ng-template #template>
    @let col = column();


    <th pResizableColumn [pResizableColumnDisabled]="col.frozen ?? false" [pSortableColumn]="$any(col.field)" [ngClass]="col.headerClass">
        <div class="flex items-center " [ngClass]="col.type === 'currency' || col.type === 'number' ? 'justify-end' : 'justify-start'">
            <div class="">{{col.header}}</div>
            <div class="flex items-center">
                @if(col.sortable) {
                    <p-sortIcon [style.display]="'flex'" class="ml-1" [field]="$any(col.field)" />
                }
                @if(col.filterable) {
                    <p-columnFilter [type]='filterType[col.type]' [field]="$any(col.field)" display="menu"  />
                }


            </div>

        </div>

    </th>
    

</ng-template>